import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'app-common-drawer',
  templateUrl: './common-drawer.component.html',
  styleUrls: ['./common-drawer.component.scss'],
})
export class CommonDrawerComponent {
  @ViewChild('drawer') drawer!: MatDrawer;

  /** Prevent native browser tooltip from the HTML title attribute. */
  @HostBinding('attr.title') hostTitle = null;

  /** Title shown at the top */
  @Input() title?: string = 'Details';

  @Input() subTitle?: string;

  /** Drawer width (default: 400px) */
  @Input() width?: string = '400px';

  /** Show/Hide submit button */
  @Input() showSubmit?: boolean = true;

  /** Submit button label */
  @Input() submitLabel: string = 'Save';

  /** Disable submit button */
  @Input() disableSubmit?: boolean;

  /** Show/Hide cancel button */
  @Input() showCancel?: boolean = true;

  /** Cancel button label */
  @Input() cancelLabel?: string = 'Cancel';

  @Input() showHeader?: boolean = true;

  @Input() drawerContentClasss?: string = '';

  /** Template dictionary for rendering reusable header blocks */
  @Input() templateRefs: Record<string, TemplateRef<any>> = {};
  /** Template name from templateRefs to render in header */
  @Input() headerTemplateRefName?: string = '';
  /** Context passed to selected header template */
  @Input() headerTemplateContext: any;

  /** Outputs */
  @Output() submitted = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  open(): void {
    this.drawer.open();
  }

  close(): void {
    this.drawer.close();
    this.closed.emit();
  }

  onSubmit(): void {
    if (!this.disableSubmit) {
      this.submitted.emit();
    }
  }

  onCancel(): void {
    this.cancelled.emit();
    this.close();
  }

  emitClosed() {
    this.closed.emit();
  }

  get resolvedHeaderTemplate(): TemplateRef<any> | null {
    if (
      this.headerTemplateRefName &&
      this.templateRefs[this.headerTemplateRefName]
    ) {
      return this.templateRefs[this.headerTemplateRefName];
    }
    return null;
  }
}
